module.exports = __webpack_public_path__ + "img/car_nosignal.026fcaac.svg";